import React from "react";

const About = () => {
  return (
    <section id="about" className="container px-8 py-16 mx-auto bg-gray-100">
      <h2 className="text-3xl font-bold text-center text-gray-900">About EzzyDental Dental</h2>
      <p className="mt-4 text-lg text-center text-gray-700">
        VYX Dental is a cutting-edge dental practice management platform designed to simplify operations, enhance patient experience, and optimize revenue.
      </p>
    </section>
  );
};

export default About;
